import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserForm } from '../../App/Types/UsersType';
import { getAllUsersByRole } from '../Services/AdminService';
import UsersAndRecruiterComponent from '../Components/UsersAndRecruiterComponent';

function UsersAndRecruiterPage() {
  const [adminData, setAdminData] = useState<UserForm[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const { role } = useParams();

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllUsersByRole(role as string);
      if (response.success) {
        setAdminData(response.data);
        setError('');
      } else {
        setError(response.message || 'Could not retrieve target role data.');
      }
    } catch (err) {
      setError('An unexpected error occurred while loading the target roles.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const roleLabel =
    role === 'recruiter' ? 'Recruiters' : role === 'candidate' ? 'Candidates' : 'Users';

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-slate-400">
        Loading users...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-rose-400">
        {error}
      </div>
    );
  }

  return (
    <UsersAndRecruiterComponent
      data={adminData}
      onEditSubmit={() => {}}
      onDeleteConfirm={() => {}}
      onRegisterSubmit={() => {}}
      menuName={roleLabel}
      role={role}
      onChanged={fetchUsers}
    />
  );
}

export default UsersAndRecruiterPage;
